import { Directive, Inject, Injector, Input, Optional, SkipSelf } from '@angular/core';
import { AlignStyle, MultiselectOptionSetControlDto, OptionSetValueDto } from '@core/services/api-clients';
import { WidgetDirective } from '@core/widgets/directives/widget.directive';
import { IScriptRunnerService, SCRIPT_RUNNER_SERVICE } from '@core/widgets/models/iscript-runner.service';
import { MultiselectControlComponent } from '@shared/reactive-controls/components/multiselect/multiselect-control.component';
import { IMultiselectOptionSetControlContext } from '../../../engine-sdk';
import { EngineFormControlDirective } from './engine-form-control.directive';

@Directive({
  selector: 'app-multiselect-control[engineMultiselectFormControl]',
  providers: [{ provide: EngineFormControlDirective, useExisting: EngineMultiselectFormControlDirective }],
})
export class EngineMultiselectFormControlDirective
  extends EngineFormControlDirective
  implements IMultiselectOptionSetControlContext
{
  private _options: OptionSetValueDto[] = [];
  protected get _multiselectBaseControl(): MultiselectControlComponent {
    return this._baseControl as MultiselectControlComponent;
  }

  @Input() set engineMultiselectControlDefinition(definition: MultiselectOptionSetControlDto) {
    this.options = definition.options;
    this.engineControlDefinition = definition;
    this.textAlignStyle = definition.textAlign;
  }
  @Input() set options(v: OptionSetValueDto[]) {
    this._options = this.getFixedOptions(v);
    this._multiselectBaseControl.options = this._options;
  }

  @Input() set textAlignStyle(textAlign: AlignStyle) {
    this._multiselectBaseControl.textAlignStyle = this.getTextAlignStyle(textAlign);
  }

  get textAlignStyle(): any {
    return this._multiselectBaseControl.textAlignStyle;
  }

  get options(): OptionSetValueDto[] {
    return this._multiselectBaseControl.options as OptionSetValueDto[];
  }

  constructor(
    @Optional() @SkipSelf() parentWidget: WidgetDirective,
    @Inject(SCRIPT_RUNNER_SERVICE) scriptRunnerService: IScriptRunnerService,
    injector: Injector,
  ) {
    super(parentWidget, scriptRunnerService, injector);
  }

  filterOptionsByName(names: string[]): void {
    this._multiselectBaseControl.options = this._options.filter((x) => names.includes(x.name));
  }

  resetOptionsFilter() {
    this.options = this._options;
  }

  // We use name as value - dk why
  private getFixedOptions(options: OptionSetValueDto[]): OptionSetValueDto[] {
    return options.map((x) => {
      return { ...x, value: x.name } as OptionSetValueDto;
    });
  }
}
